import { APP_STORE_URL, PLAY_STORE_URL } from "@/lib/config";

const APPLE = (
  <svg viewBox="0 0 384 512" className="size-[18px] shrink-0" aria-hidden>
    <path
      fill="currentColor"
      d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
    />
  </svg>
);

const PLAY = (
  <svg viewBox="0 0 24 24" className="size-[18px] shrink-0" aria-hidden>
    <path fill="currentColor" d="M4.3 2.4c-.4.3-.6.8-.6 1.4v16.4c0 .6.2 1.1.6 1.4l9.4-9.6-9.4-9.6Zm10.7 8.2 2.7-2.8L6.4 1.4c-.4-.2-.8-.3-1.1-.2l9.7 9.4Zm0 2.8-9.7 9.4c.3.1.7 0 1.1-.2l11.3-6.4-2.7-2.8Zm3.9-4.9-3 3.1 3 3.1 3.3-1.9c1-.6 1-2 0-2.5l-3.3-1.8Z" />
  </svg>
);

function Badge({ href, glyph, small, big, compact, light }: { href: string; glyph: React.ReactNode; small: string; big: string; compact?: boolean; light?: boolean }) {
  const soon = href === "#";
  return (
    <a
      href={href}
      onClick={soon ? e => e.preventDefault() : undefined}
      aria-label={`${small} ${big}${soon ? " (coming soon)" : ""}`}
      aria-disabled={soon || undefined}
      className={`inline-flex w-full items-center justify-center gap-2.5 ${light ? "rounded-2xl border-2 border-b-[5px] border-[#E7E3F0]" : "rounded-full border-b-4 border-[#CECBF6]"} bg-white text-[#1C1A27] transition hover:-translate-y-px hover:brightness-[1.03] active:translate-y-0.5 active:border-b-2 ${compact ? "h-11 px-4" : "h-[52px] px-5"} ${soon ? "cursor-default" : ""}`}
    >
      {glyph}
      <span className="flex flex-col text-left font-sans leading-none">
        <span className={`font-bold text-[#1C1A27]/60 ${compact ? "text-[10px]" : "text-[11px]"}`}>{small}</span>
        <span className={`font-black tracking-[0.01em] whitespace-nowrap ${compact ? "mt-[3px] text-[14px]" : "mt-1 text-base"}`}>{big}</span>
      </span>
    </a>
  );
}

/** Drawn App Store / Google Play buttons (not the official badge files). */
/** `light`: on the day (light) part of the page, as app slab buttons. */
export function StoreBadges({ compact, center, note = true, light }: { compact?: boolean; center?: boolean; note?: boolean; light?: boolean }) {
  const soon = APP_STORE_URL === "#" || PLAY_STORE_URL === "#";
  return (
    <div className={`flex flex-col gap-2 ${center ? "items-center" : "items-start"}`}>
      <div className={`grid grid-cols-2 gap-2 ${compact ? "w-[min(100%,340px)]" : "w-[min(100%,380px)]"}`}>
        <Badge href={APP_STORE_URL} glyph={APPLE} small="Download on the" big="App Store" compact={compact} light={light} />
        <Badge href={PLAY_STORE_URL} glyph={PLAY} small="Get it on" big="Google Play" compact={compact} light={light} />
      </div>
      {note && soon && <p className={`text-[11.5px] font-bold ${light ? "text-[#8A8698]" : "text-[rgba(220,215,255,0.42)]"}`}>Coming soon to iPhone and Android</p>}
    </div>
  );
}
